window.IR_SECOND_PAGE_PRINTER_SECTION_CATALOGS = window.IR_SECOND_PAGE_PRINTER_SECTION_CATALOGS || {};
window.IR_SECOND_PAGE_PRINTER_SECTION_CATALOGS["others-printer-t"] = {
  "sectionCount": 14,
  "groupCount": 35,
  "modelCount": 155,
  "sections": [
    {
      "order": 1,
      "title": "NECレーザープリンター型番一覧",
      "note": "",
      "groups": [
        {
          "order": 1,
          "name": "Multiwriter-4×××シリーズ",
          "models": [
            {
              "order": 1,
              "model": "400F",
              "shopifyUrl": "/collections/400f"
            }
          ]
        },
        {
          "order": 2,
          "name": "Multiwriter-5×××シリーズ",
          "models": [
            {
              "order": 1,
              "model": "5100",
              "shopifyUrl": "/collections/5100"
            },
            {
              "order": 2,
              "model": "5100F",
              "shopifyUrl": "/collections/5100f"
            },
            {
              "order": 3,
              "model": "5300",
              "shopifyUrl": "/collections/5300"
            },
            {
              "order": 4,
              "model": "5850C",
              "shopifyUrl": "/collections/5850c"
            }
          ]
        },
        {
          "order": 3,
          "name": "Multiwriter-8×××シリーズ",
          "models": [
            {
              "order": 1,
              "model": "8600",
              "shopifyUrl": "/collections/8600"
            },
            {
              "order": 2,
              "model": "8700",
              "shopifyUrl": "/collections/8700"
            },
            {
              "order": 3,
              "model": "8800",
              "shopifyUrl": "/collections/8800"
            }
          ]
        },
        {
          "order": 4,
          "name": "Multiwriter-PR-L2×××シリーズ",
          "models": [
            {
              "order": 1,
              "model": "L200F",
              "shopifyUrl": "/collections/l200f"
            },
            {
              "order": 12,
              "model": "L2800",
              "shopifyUrl": "/collections/l2800"
            },
            {
              "order": 13,
              "model": "L2800N",
              "shopifyUrl": "/collections/l2800n"
            },
            {
              "order": 14,
              "model": "L2830N",
              "shopifyUrl": "/collections/l2830n"
            },
            {
              "order": 15,
              "model": "L2850",
              "shopifyUrl": "/collections/l2850"
            },
            {
              "order": 16,
              "model": "L2850N",
              "shopifyUrl": "/collections/l2850n"
            },
            {
              "order": 17,
              "model": "L2860N",
              "shopifyUrl": "/collections/l2860n"
            },
            {
              "order": 18,
              "model": "L2900C",
              "shopifyUrl": "/collections/l2900c"
            }
          ]
        },
        {
          "order": 5,
          "name": "Multiwriter-PR-L5×××シリーズ",
          "models": [
            {
              "order": 1,
              "model": "L5150",
              "shopifyUrl": "/collections/l5150"
            },
            {
              "order": 2,
              "model": "L5140",
              "shopifyUrl": "/collections/l5140"
            },
            {
              "order": 3,
              "model": "L5500",
              "shopifyUrl": "/collections/l5500"
            },
            {
              "order": 4,
              "model": "L5500P",
              "shopifyUrl": "/collections/l5500p"
            },
            {
              "order": 5,
              "model": "L5600C",
              "shopifyUrl": "/collections/l5600c"
            },
            {
              "order": 6,
              "model": "L5650C",
              "shopifyUrl": "/collections/l5650c"
            },
            {
              "order": 7,
              "model": "L5650F",
              "shopifyUrl": "/collections/l5650f"
            },
            {
              "order": 9,
              "model": "L5700C",
              "shopifyUrl": "/collections/l5700c"
            },
            {
              "order": 10,
              "model": "L5750C",
              "shopifyUrl": "/collections/l5750c"
            },
            {
              "order": 11,
              "model": "L5900C",
              "shopifyUrl": "/collections/l5900c"
            },
            {
              "order": 12,
              "model": "L5900CP",
              "shopifyUrl": "/collections/l5900cp"
            },
            {
              "order": 13,
              "model": "L5900C2",
              "shopifyUrl": "/collections/l5900c2"
            },
            {
              "order": 14,
              "model": "L5900CP2",
              "shopifyUrl": "/collections/l5900cp2"
            }
          ]
        },
        {
          "order": 6,
          "name": "Multiwriter-PR-L8×××シリーズ",
          "models": [
            {
              "order": 1,
              "model": "L8200",
              "shopifyUrl": "/collections/l8200"
            },
            {
              "order": 2,
              "model": "L8200N",
              "shopifyUrl": "/collections/l8200n"
            },
            {
              "order": 3,
              "model": "L8250",
              "shopifyUrl": "/collections/l8250"
            },
            {
              "order": 4,
              "model": "L8250N",
              "shopifyUrl": "/collections/l8250n"
            },
            {
              "order": 6,
              "model": "L8400N",
              "shopifyUrl": "/collections/l8400n"
            },
            {
              "order": 7,
              "model": "L8450N",
              "shopifyUrl": "/collections/l8450n"
            },
            {
              "order": 8,
              "model": "L8450NW",
              "shopifyUrl": "/collections/l8450nw"
            },
            {
              "order": 9,
              "model": "L8500N",
              "shopifyUrl": "/collections/l8500n"
            }
          ]
        },
        {
          "order": 7,
          "name": "Multiwriter-PR-L9×××シリーズ",
          "models": [
            {
              "order": 1,
              "model": "L9100C",
              "shopifyUrl": "/collections/l9100c"
            }
          ]
        }
      ]
    },
    {
      "order": 2,
      "title": "FUJITSUレーザープリンター型番一覧",
      "note": "",
      "groups": [
        {
          "order": 1,
          "name": "Printia-LASERシリーズ",
          "models": [
            {
              "order": 1,
              "model": "XL-4340",
              "shopifyUrl": "/collections/xl-4340"
            },
            {
              "order": 2,
              "model": "XL-9280",
              "shopifyUrl": "/collections/xl-9280"
            },
            {
              "order": 3,
              "model": "XL-9281",
              "shopifyUrl": "/collections/xl-9281"
            },
            {
              "order": 4,
              "model": "XL-9310",
              "shopifyUrl": "/collections/xl-9310"
            },
            {
              "order": 5,
              "model": "XL-9311",
              "shopifyUrl": "/collections/xl-9311"
            },
            {
              "order": 6,
              "model": "XL-9321",
              "shopifyUrl": "/collections/xl-9321"
            },
            {
              "order": 7,
              "model": "XL-9380",
              "shopifyUrl": "/collections/xl-9380"
            },
            {
              "order": 8,
              "model": "XL-9380E",
              "shopifyUrl": "/collections/xl-9380e"
            },
            {
              "order": 9,
              "model": "XL-9381",
              "shopifyUrl": "/collections/xl-9381"
            },
            {
              "order": 10,
              "model": "XL-9440",
              "shopifyUrl": "/collections/xl-9440"
            },
            {
              "order": 11,
              "model": "XL-9440D",
              "shopifyUrl": "/collections/xl-9440d"
            },
            {
              "order": 12,
              "model": "XL-9440E",
              "shopifyUrl": "/collections/xl-9440e"
            }
          ]
        }
      ]
    },
    {
      "order": 3,
      "title": "FUJIxeroxレーザープリンター型番一覧",
      "note": "",
      "groups": [
        {
          "order": 1,
          "name": "DocuPrintシリーズ",
          "models": [
            {
              "order": 1,
              "model": "DocuPrint-C2450d",
              "shopifyUrl": "/collections/docuprint-c2450d"
            },
            {
              "order": 2,
              "model": "DocuPrint-2055",
              "shopifyUrl": "/collections/docuprint-2055"
            },
            {
              "order": 3,
              "model": "DocuPrint-3000",
              "shopifyUrl": "/collections/docuprint-3000"
            },
            {
              "order": 4,
              "model": "DocuPrint-3010",
              "shopifyUrl": "/collections/docuprint-3010"
            },
            {
              "order": 5,
              "model": "DocuPrint-3100",
              "shopifyUrl": "/collections/docuprint-3100"
            },
            {
              "order": 6,
              "model": "DocuPrint-3100",
              "shopifyUrl": "/collections/docuprint-3100"
            },
            {
              "order": 7,
              "model": "DocuPrint-3500d",
              "shopifyUrl": "/collections/docuprint-3500d"
            },
            {
              "order": 8,
              "model": "DocuPrint-4050",
              "shopifyUrl": "/collections/docuprint-4050"
            },
            {
              "order": 9,
              "model": "DocuPrint-4400d",
              "shopifyUrl": "/collections/docuprint-4400d"
            },
            {
              "order": 10,
              "model": "DocuPrint-C1100",
              "shopifyUrl": "/collections/docuprint-c1100"
            },
            {
              "order": 11,
              "model": "DocuPrint-C2110",
              "shopifyUrl": "/collections/docuprint-c2110"
            },
            {
              "order": 12,
              "model": "DocuPrint-C3350",
              "shopifyUrl": "/collections/docuprint-c3350"
            },
            {
              "order": 13,
              "model": "DocuPrint-C3350S",
              "shopifyUrl": "/collections/docuprint-c3350s"
            },
            {
              "order": 14,
              "model": "DocuPrint-C3450d",
              "shopifyUrl": "/collections/docuprint-c3450d"
            },
            {
              "order": 15,
              "model": "DocuPrint-C4000d",
              "shopifyUrl": "/collections/docuprint-c4000d"
            },
            {
              "order": 16,
              "model": "DocuPrint-CM200-b",
              "shopifyUrl": "/collections/docuprint-cm200-b"
            },
            {
              "order": 17,
              "model": "DocuPrint-CM200-fw",
              "shopifyUrl": "/collections/docuprint-cm200-fw"
            },
            {
              "order": 18,
              "model": "DocuPrint-CP100-b",
              "shopifyUrl": "/collections/docuprint-cp100-b"
            },
            {
              "order": 19,
              "model": "DocuPrint-CP200-w",
              "shopifyUrl": "/collections/docuprint-cp200-w"
            },
            {
              "order": 20,
              "model": "DocuPrint-M200-fw",
              "shopifyUrl": "/collections/docuprint-m200-fw"
            },
            {
              "order": 21,
              "model": "DocuPrint-M260z",
              "shopifyUrl": "/collections/docuprint-m260z"
            },
            {
              "order": 22,
              "model": "DocuPrint-P200-b",
              "shopifyUrl": "/collections/docuprint-p200-b"
            },
            {
              "order": 23,
              "model": "DocuPrint-P260dw",
              "shopifyUrl": "/collections/docuprint-p260dw"
            },
            {
              "order": 24,
              "model": "DocuPrint-P350-d",
              "shopifyUrl": "/collections/docuprint-p350-d"
            },
            {
              "order": 25,
              "model": "DocuPrint-P450-d",
              "shopifyUrl": "/collections/docuprint-p450-d"
            },
            {
              "order": 26,
              "model": "DocuPrint-P450-JM",
              "shopifyUrl": "/collections/docuprint-p450-jm"
            },
            {
              "order": 27,
              "model": "DocuPrint-P450-ps",
              "shopifyUrl": "/collections/docuprint-p450-ps"
            }
          ]
        }
      ]
    },
    {
      "order": 4,
      "title": "OKIレーザープリンター型番一覧",
      "note": "",
      "groups": [
        {
          "order": 1,
          "name": "COREFIDOシリーズ",
          "models": [
            {
              "order": 1,
              "model": "COREFIDO-C332dnw",
              "shopifyUrl": "/collections/corefido-c332dnw"
            },
            {
              "order": 2,
              "model": "COREFIDO-B411dn",
              "shopifyUrl": "/collections/corefido-b411dn"
            },
            {
              "order": 3,
              "model": "COREFIDO-B411dnB",
              "shopifyUrl": "/collections/corefido-b411dnb"
            },
            {
              "order": 4,
              "model": "COREFIDO-B431dn",
              "shopifyUrl": "/collections/corefido-b431dn"
            },
            {
              "order": 5,
              "model": "COREFIDO-B431dnB",
              "shopifyUrl": "/collections/corefido-b431dnb"
            },
            {
              "order": 6,
              "model": "COREFIDO-B432dnw",
              "shopifyUrl": "/collections/corefido-b432dnw"
            },
            {
              "order": 7,
              "model": "COREFIDO-B4500n",
              "shopifyUrl": "/collections/corefido-b4500n"
            },
            {
              "order": 8,
              "model": "COREFIDO-C301dn",
              "shopifyUrl": "/collections/corefido-c301dn"
            },
            {
              "order": 9,
              "model": "COREFIDO-C310dn",
              "shopifyUrl": "/collections/corefido-c310dn"
            },
            {
              "order": 10,
              "model": "COREFIDO-C510dn",
              "shopifyUrl": "/collections/corefido-c510dn"
            },
            {
              "order": 11,
              "model": "COREFIDO-C530dn",
              "shopifyUrl": "/collections/corefido-c530dn"
            },
            {
              "order": 12,
              "model": "COREFIDO-C810dn",
              "shopifyUrl": "/collections/corefido-c810dn"
            },
            {
              "order": 13,
              "model": "COREFIDO-C811dn-T",
              "shopifyUrl": "/collections/corefido-c811dn-t"
            },
            {
              "order": 14,
              "model": "COREFIDO-C811dn",
              "shopifyUrl": "/collections/corefido-c811dn"
            },
            {
              "order": 15,
              "model": "COREFIDO-C830dn",
              "shopifyUrl": "/collections/corefido-c830dn"
            },
            {
              "order": 16,
              "model": "COREFIDO-C841dn-PI",
              "shopifyUrl": "/collections/corefido-c841dn-pi"
            },
            {
              "order": 17,
              "model": "COREFIDO-C841dn",
              "shopifyUrl": "/collections/corefido-c841dn"
            },
            {
              "order": 18,
              "model": "COREFIDO-MC361dn",
              "shopifyUrl": "/collections/corefido-mc361dn"
            },
            {
              "order": 19,
              "model": "COREFIDO-MC561dn",
              "shopifyUrl": "/collections/corefido-mc561dn"
            },
            {
              "order": 20,
              "model": "COREFIDO-MC860dn",
              "shopifyUrl": "/collections/corefido-mc860dn"
            },
            {
              "order": 21,
              "model": "COREFIDO-MC860dtn",
              "shopifyUrl": "/collections/corefido-mc860dtn"
            },
            {
              "order": 22,
              "model": "COREFIDO-MC363dnw",
              "shopifyUrl": "/collections/corefido-mc363dnw"
            },
            {
              "order": 23,
              "model": "COREFIDO-B821n-T",
              "shopifyUrl": "/collections/corefido-b821n-t"
            },
            {
              "order": 24,
              "model": "COREFIDO-B841dn",
              "shopifyUrl": "/collections/corefido-b841dn"
            }
          ]
        }
      ]
    },
    {
      "order": 5,
      "title": "IBMレーザープリンター型番一覧",
      "note": "",
      "groups": [
        {
          "order": 1,
          "name": "5596シリーズ",
          "models": [
            {
              "order": 1,
              "model": "5596-7M4",
              "shopifyUrl": "/collections/5596-7m4"
            },
            {
              "order": 2,
              "model": "5596-7M6",
              "shopifyUrl": "/collections/5596-7m6"
            },
            {
              "order": 3,
              "model": "5596-7P4",
              "shopifyUrl": "/collections/5596-7p4"
            },
            {
              "order": 4,
              "model": "5596-7P6",
              "shopifyUrl": "/collections/5596-7p6"
            }
          ]
        },
        {
          "order": 2,
          "name": "5584シリーズ",
          "models": [
            {
              "order": 1,
              "model": "5584-5M2",
              "shopifyUrl": "/collections/5584-5m2"
            }
          ]
        },
        {
          "order": 3,
          "name": "InfoPrintシリーズ",
          "models": [
            {
              "order": 1,
              "model": "InfoPrint1522J",
              "shopifyUrl": "/collections/infoprint1522j"
            },
            {
              "order": 2,
              "model": "InfoPrint1736J",
              "shopifyUrl": "/collections/infoprint1736j"
            },
            {
              "order": 3,
              "model": "InfoPrint1756J",
              "shopifyUrl": "/collections/infoprint1756j"
            }
          ]
        }
      ]
    },
    {
      "order": 6,
      "title": "日立レーザープリンター型番一覧",
      "note": "",
      "groups": [
        {
          "order": 1,
          "name": "Prinfina-LASER-BXシリーズ",
          "models": [
            {
              "order": 1,
              "model": "Prinfina-LASER-BX2640",
              "shopifyUrl": "/collections/prinfina-laser-bx2640"
            },
            {
              "order": 2,
              "model": "Prinfina-LASER-BX3530",
              "shopifyUrl": "/collections/prinfina-laser-bx3530"
            },
            {
              "order": 3,
              "model": "Prinfina-LASER-BX3540",
              "shopifyUrl": "/collections/prinfina-laser-bx3540"
            }
          ]
        }
      ]
    },
    {
      "order": 7,
      "title": "パナソニックレーザープリンター型番一覧",
      "note": "",
      "groups": [
        {
          "order": 1,
          "name": "MVシリーズ",
          "models": [
            {
              "order": 1,
              "model": "MV-HPRB30A",
              "shopifyUrl": "/collections/mv-hprb30a"
            }
          ]
        },
        {
          "order": 2,
          "name": "magicolorシリーズ",
          "models": [
            {
              "order": 1,
              "model": "magicolor7440",
              "shopifyUrl": "/collections/magicolor7440"
            },
            {
              "order": 2,
              "model": "magicolor7450",
              "shopifyUrl": "/collections/magicolor7450"
            }
          ]
        },
        {
          "order": 3,
          "name": "MEMOREXシリーズ",
          "models": [
            {
              "order": 1,
              "model": "MEMOREX-M1913",
              "shopifyUrl": "/collections/memorex-m1913"
            }
          ]
        },
        {
          "order": 4,
          "name": "Mシリーズ",
          "models": [
            {
              "order": 1,
              "model": "M3540idn",
              "shopifyUrl": "/collections/m3540idn"
            },
            {
              "order": 2,
              "model": "M3645idn",
              "shopifyUrl": "/collections/m3645idn"
            }
          ]
        },
        {
          "order": 5,
          "name": "Pシリーズ",
          "models": [
            {
              "order": 1,
              "model": "ECOSYS-P2040dw",
              "shopifyUrl": "/collections/ecosys-p2040dw"
            },
            {
              "order": 2,
              "model": "ECOSYS-P3045dn",
              "shopifyUrl": "/collections/ecosys-p3045dn"
            },
            {
              "order": 3,
              "model": "ECOSYS-P3145dn",
              "shopifyUrl": "/collections/ecosys-p3145dn"
            },
            {
              "order": 4,
              "model": "ECOSYS-P2135dn",
              "shopifyUrl": "/collections/ecosys-p2135dn"
            }
          ]
        },
        {
          "order": 6,
          "name": "FSシリーズ",
          "models": [
            {
              "order": 1,
              "model": "FS-1300D",
              "shopifyUrl": "/collections/fs-1300d"
            },
            {
              "order": 2,
              "model": "FS-1370DN",
              "shopifyUrl": "/collections/fs-1370dn"
            }
          ]
        },
        {
          "order": 7,
          "name": "LSシリーズ",
          "models": [
            {
              "order": 1,
              "model": "LS-1028MFP",
              "shopifyUrl": "/collections/ls-1028mfp"
            },
            {
              "order": 2,
              "model": "LS-1128MFP",
              "shopifyUrl": "/collections/ls-1128mfp"
            },
            {
              "order": 3,
              "model": "LS-2020D",
              "shopifyUrl": "/collections/ls-2020d"
            },
            {
              "order": 4,
              "model": "LS-2100DN",
              "shopifyUrl": "/collections/ls-2100dn"
            },
            {
              "order": 5,
              "model": "LS-6970DN",
              "shopifyUrl": "/collections/ls-6970dn"
            }
          ]
        },
        {
          "order": 8,
          "name": "LPシリーズ",
          "models": [
            {
              "order": 1,
              "model": "LP28F",
              "shopifyUrl": "/collections/lp28f"
            }
          ]
        },
        {
          "order": 9,
          "name": "WDシリーズ",
          "models": [
            {
              "order": 1,
              "model": "WD-08LP",
              "shopifyUrl": "/collections/wd-08lp"
            }
          ]
        },
        {
          "order": 10,
          "name": "PowerLaserシリーズ",
          "models": [
            {
              "order": 1,
              "model": "PowerLaser-Z7028",
              "shopifyUrl": "/collections/powerlaser-z7028"
            },
            {
              "order": 2,
              "model": "PowerLaser-Z7035",
              "shopifyUrl": "/collections/powerlaser-z7035"
            }
          ]
        },
        {
          "order": 11,
          "name": "MC-Pシリーズ",
          "models": [
            {
              "order": 1,
              "model": "MC-P4420PG",
              "shopifyUrl": "/collections/mc-p4420pg"
            }
          ]
        }
      ]
    },
    {
      "order": 8,
      "title": "コニカミノルタレーザープリンター型番一覧",
      "note": "",
      "groups": [
        {
          "order": 1,
          "name": "magicolorシリーズ",
          "models": [
            {
              "order": 1,
              "model": "magicolor7440",
              "shopifyUrl": "/collections/magicolor7440"
            },
            {
              "order": 2,
              "model": "magicolor7450",
              "shopifyUrl": "/collections/magicolor7450"
            }
          ]
        }
      ]
    },
    {
      "order": 9,
      "title": "ムラテック（muratec）レーザープリンター型番一覧",
      "note": "",
      "groups": [
        {
          "order": 1,
          "name": "MEMOREXシリーズ",
          "models": [
            {
              "order": 1,
              "model": "MEMOREX-M1913",
              "shopifyUrl": "/collections/memorex-m1913"
            }
          ]
        }
      ]
    },
    {
      "order": 10,
      "title": "京セラ（KYOCERA）レーザープリンター型番一覧",
      "note": "",
      "groups": [
        {
          "order": 1,
          "name": "Mシリーズ",
          "models": [
            {
              "order": 1,
              "model": "M3540idn",
              "shopifyUrl": "/collections/m3540idn"
            },
            {
              "order": 2,
              "model": "M3645idn",
              "shopifyUrl": "/collections/m3645idn"
            }
          ]
        },
        {
          "order": 2,
          "name": "Pシリーズ",
          "models": [
            {
              "order": 1,
              "model": "ECOSYS-P2040dw",
              "shopifyUrl": "/collections/ecosys-p2040dw"
            },
            {
              "order": 2,
              "model": "ECOSYS-P3045dn",
              "shopifyUrl": "/collections/ecosys-p3045dn"
            },
            {
              "order": 3,
              "model": "ECOSYS-P3145dn",
              "shopifyUrl": "/collections/ecosys-p3145dn"
            },
            {
              "order": 4,
              "model": "ECOSYS-P2135dn",
              "shopifyUrl": "/collections/ecosys-p2135dn"
            }
          ]
        },
        {
          "order": 3,
          "name": "FSシリーズ",
          "models": [
            {
              "order": 1,
              "model": "FS-1300D",
              "shopifyUrl": "/collections/fs-1300d"
            },
            {
              "order": 2,
              "model": "FS-1370DN",
              "shopifyUrl": "/collections/fs-1370dn"
            }
          ]
        },
        {
          "order": 4,
          "name": "LSシリーズ",
          "models": [
            {
              "order": 1,
              "model": "LS-1028MFP",
              "shopifyUrl": "/collections/ls-1028mfp"
            },
            {
              "order": 2,
              "model": "LS-1128MFP",
              "shopifyUrl": "/collections/ls-1128mfp"
            },
            {
              "order": 3,
              "model": "LS-2020D",
              "shopifyUrl": "/collections/ls-2020d"
            },
            {
              "order": 4,
              "model": "LS-2100DN",
              "shopifyUrl": "/collections/ls-2100dn"
            },
            {
              "order": 5,
              "model": "LS-6970DN",
              "shopifyUrl": "/collections/ls-6970dn"
            }
          ]
        }
      ]
    },
    {
      "order": 11,
      "title": "JDLレーザープリンター型番一覧",
      "note": "",
      "groups": [
        {
          "order": 1,
          "name": "LPシリーズ",
          "models": [
            {
              "order": 1,
              "model": "LP28F",
              "shopifyUrl": "/collections/lp28f"
            }
          ]
        }
      ]
    },
    {
      "order": 12,
      "title": "シャープ（SHARP）レーザープリンター型番一覧",
      "note": "",
      "groups": [
        {
          "order": 1,
          "name": "WDシリーズ",
          "models": [
            {
              "order": 1,
              "model": "WD-08LP",
              "shopifyUrl": "/collections/wd-08lp"
            }
          ]
        }
      ]
    },
    {
      "order": 13,
      "title": "アプティ（APTI）レーザープリンター型番一覧",
      "note": "",
      "groups": [
        {
          "order": 1,
          "name": "PowerLaserシリーズ",
          "models": [
            {
              "order": 1,
              "model": "PowerLaser-Z7028",
              "shopifyUrl": "/collections/powerlaser-z7028"
            },
            {
              "order": 2,
              "model": "PowerLaser-Z7035",
              "shopifyUrl": "/collections/powerlaser-z7035"
            }
          ]
        }
      ]
    },
    {
      "order": 14,
      "title": "三洋電機（SANYO）レーザープリンター型番一覧",
      "note": "",
      "groups": [
        {
          "order": 1,
          "name": "MC-Pシリーズ",
          "models": [
            {
              "order": 1,
              "model": "MC-P4420PG",
              "shopifyUrl": "/collections/mc-p4420pg"
            }
          ]
        }
      ]
    }
  ]
};
